// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const ox = defineModel({
  id: "ox",
  scale: 2.3, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Ox",
  tags: ["creature","ox","low-poly","age-of-mcp","future"],
  summary: "An ox — heavy draught power for ploughs and wagons.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.16,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.016, 0.014, 0.11, 6), color: "#4a3422", position: [0.08, 0.055, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.017, 0.017, 0.014, 6), color: "#22160e", position: [0.08, 0.007, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.016, 0.014, 0.11, 6), color: "#4a3422", position: [0.08, 0.055, -0.05] },
      { geometry: new THREE.CylinderGeometry(0.017, 0.017, 0.014, 6), color: "#22160e", position: [0.08, 0.007, -0.05] },
      { geometry: new THREE.CylinderGeometry(0.016, 0.014, 0.11, 6), color: "#4a3422", position: [-0.08, 0.055, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.017, 0.017, 0.014, 6), color: "#22160e", position: [-0.08, 0.007, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.016, 0.014, 0.11, 6), color: "#4a3422", position: [-0.08, 0.055, -0.05] },
      { geometry: new THREE.CylinderGeometry(0.017, 0.017, 0.014, 6), color: "#22160e", position: [-0.08, 0.007, -0.05] },
      { geometry: new THREE.BoxGeometry(0.19, 0.1, 0.11), color: "#4a3422", position: [0, 0.16, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#5a4028", position: [0.06, 0.205, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.07, 0.075), color: "#5a4028", position: [0.12, 0.145, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.06), color: "#6e5440", position: [0.158, 0.135, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#0c0805", position: [0.168, 0.142, 0.018] },
      { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#0c0805", position: [0.168, 0.142, -0.018] },
      { geometry: new THREE.ConeGeometry(0.012, 0.07, 5), color: "#d8cbb0", position: [0.11, 0.185, 0.05], rotation: [-1.3, 0, 0.2] },
      { geometry: new THREE.ConeGeometry(0.012, 0.07, 5), color: "#d8cbb0", position: [0.11, 0.185, -0.05], rotation: [1.3, 0, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#4a3422", position: [0.1, 0.165, 0.05], scale: [0.6, 0.5, 1.4] },
      { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#4a3422", position: [0.1, 0.165, -0.05], scale: [0.6, 0.5, 1.4] },
      { geometry: new THREE.IcosahedronGeometry(0.006, 0), color: "#0c0805", position: [0.142, 0.158, 0.03] },
      { geometry: new THREE.IcosahedronGeometry(0.006, 0), color: "#0c0805", position: [0.142, 0.158, -0.03] },
      { geometry: new THREE.CylinderGeometry(0.007, 0.005, 0.1, 4), color: "#4a3422", position: [-0.108, 0.1, 0], rotation: [0, 0, 2.4] },
      { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#22160e", position: [-0.142, 0.062, 0] },
    ],
  animations: [],
});
